<template>
  <div class="BusinessManage">
        <div>
          <el-form ref="ruleForm" label-width="100px">
                <el-row>
                    <el-col :span="5" v-if="str.system ==1 && str.type == 1">
                        <el-form-item label="商务组长">
                            <el-select v-model="ruleForm.GroupLeader" placeholder="请选择" @change="SelectGroup">
                                <el-option
                                    v-for="item in GroupLeaderList"
                                    :key="item.rid"
                                    :label="item.roleName"
                                    :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="商务组员" v-if="str.system ==1 && str.type == 1||str.system == 4 && str.superDepartmentName == '商务部' && str.type ==2">
                            <el-select v-model="ruleForm.TeamMembers" placeholder="请选择">
                                <el-option
                                    v-for="item in TeamMembersList"
                                    :key="item.rid"
                                    :label="item.roleName"
                                    :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="开始日期">
                            <el-date-picker
                                v-model="ruleForm.starttime"
                                type="date"
                                @change="startDate"
                                placeholder="选择开始日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="结束日期">
                            <el-date-picker
                                v-model="ruleForm.endtime"
                                type="date"
                                @change="endDate"
                                placeholder="选择结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label class="search">
                            <el-input v-model="ruleForm.input" placeholder="公司名称搜索" style="width: 60%;"></el-input>
                            <el-button type="primary" style="margin-left: 15px;" @click="search2">搜索</el-button>
                            <el-button type="primary" @click="searchReset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div>
            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column align="center" prop="companyCode" label="公司编码"></el-table-column>
                    <el-table-column align="center" prop="parentCompanyName" label="所属分公司"></el-table-column>
                    <el-table-column align="center" prop="companyFullName" label="公司全称"></el-table-column>
                    <el-table-column align="center" label="公司余额">
                        <template slot-scope="scope">
                            <p>实际余额：{{scope.row.balance}}</p>
                            <p>可用余额：{{scope.row.buckleBalance}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="legalPerson" label="法人名称"></el-table-column>
                    <el-table-column align="center" label="注册时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createtimeutc == null">-</span>
                            <span v-if="scope.row.createtimeutc !== null">{{scope.row.createtimeutc}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="createtime" label="创建时间"></el-table-column>
                    <el-table-column align="center" label="商务组长">
                        <template slot-scope="scope">
                            <span v-if="scope.row.promotionCommissionRoleUserName1 == ''">-</span>
                            <span v-if="scope.row.promotionCommissionRoleUserName1 !== ''">{{scope.row.promotionCommissionRoleUserName1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="商务组员">
                        <template slot-scope="scope">
                            <span v-if="scope.row.promotionCommissionRoleUserName == ''">-</span>
                            <span v-if="scope.row.promotionCommissionRoleUserName !== ''">{{scope.row.promotionCommissionRoleUserName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="170">
                        <template slot-scope="scope">
                            <el-button @click="Edit(scope.row)" type="primary" icon="el-icon-view"></el-button>
                        </template>
                    </el-table-column>
            </el-table>
        </div>

        <el-dialog title="公司详情" :visible.sync="dialogFormVisible" width="50%" >
            <el-form style="width: 95%;" label-width="110px" class="theForm">
                <el-form-item label="公司编码：">
                    <span>{{ this.form.companyCode }}</span>
                </el-form-item>
                <el-form-item label="企业全称：">
                    <span>{{this.form.fullname}}</span>
                </el-form-item>
                <div style="overflow: hidden;">
                    <el-form-item label="公司中文简称：" class="left">
                        <span>{{this.form.chineseShortName}}</span>
                    </el-form-item>
                    <el-form-item label="公司英文简称：" class="left">
                        <span>{{this.form.englishShortName}}</span>
                    </el-form-item>
                </div>
                <el-form-item label="法人名称：">
                    <span>{{this.form.legalPerson}}</span>
                </el-form-item>
                <el-form-item label="办公地址：">
                    <span>{{this.form.companyAddress}}</span>
                </el-form-item>
                <el-form-item label="经营范围：">
                    <span>{{this.form.scopeOperation}}</span>
                </el-form-item>
                <el-form-item label="电话：">
                    <span>{{this.form.telephone}}</span>
                </el-form-item>
                <el-form-item label="员工数量限制：">
                    <span>{{this.form.companyMemberMax}}</span>
                </el-form-item>
                <el-form-item label="平台费用提成：" v-if="this.form.feeType === 1">
                    <span>{{this.form.extract}}%</span>
                </el-form-item>

                <el-form-item label="服务费" v-if="this.form.feeType == 2">
                    <el-table :data="form.handleFees" border>
                        <el-table-column label="重量/kg" align="center">
                            <template slot-scope="scope">
                                <span>{{scope.row.weight}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  label="基本包材费元/件" align="center">
                            <template slot-scope="scope">
                                <span>{{scope.row.packPrice}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  label="操作费元/件" align="center">
                            <template slot-scope="scope">
                                <span>{{scope.row.operatingPrice}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
        </div>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../api/api/api";
export default {
    name: "BusinessManage",
    data() {
        return {
            str:"",
            loading:true,
            dialogFormVisible:false,
            ruleForm:{
                starttime:"",
                endtime:"",
                GroupLeader:"",
                TeamMembers:"",
                input:""
            },
            tableData:[],
            GroupLeaderList:[],
            TeamMembersList:[],

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

            promoterId:"",
            form:"",
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        if(this.str.system ==1 && this.str.type == 1){
            this.GroupLeaderAjax()
        }else if(this.str.system == 4 && this.str.superDepartmentName == '商务部' && this.str.type ==2){
            this.promoterId = this.str.rid
            this.TeamMembersAjax()
        }
        this.search();
    },
    methods: {
      search2(){
          this.currentPage = 1
          this.search()
      },
      search(){
          this.loading = true
          var obj = {
              rid:this.str.rid,
              promoterId1:this.ruleForm.GroupLeader,
              promoterId:this.ruleForm.TeamMembers,
              startTime:this.ruleForm.starttime,
              endTime:this.ruleForm.endtime,
              page:this.currentPage,
              size:this.size,
              searchString:this.ruleForm.input
          }
          ajaxPost(Baseurl + "roleController/selectCompanyListByCondition",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                }
                this.loading = false
            });
      },
      searchReset(){
          this.ruleForm.GroupLeader = ""
          this.ruleForm.TeamMembers = ""
          this.ruleForm.starttime = ""
          this.ruleForm.endtime = ""
          this.ruleForm.input = ""
          this.currentPage = 1
          this.search()
      },
      GroupLeaderAjax(){
          ajaxPost(Baseurl + "roleController/selectAllFirstPromoterList").then(res => {
                if(res.data.code == 200){
                    this.GroupLeaderList = res.data.data
                }
            });
      },
      TeamMembersAjax(){
          var obj = {
              promoterId1:this.promoterId
          }
          ajaxPost(Baseurl + "roleController/selectSecondPromoterListByPromoterId1",obj).then(res => {
                if(res.data.code == 200){
                    this.TeamMembersList = res.data.data
                }
            });
      },
      SelectGroup(val){
        //   console.log(val)
          this.promoterId = val
          this.TeamMembersAjax()
      },
      Edit(val){
          this.form = val
          this.dialogFormVisible = true
      },
      startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
    }
}
</script>

<style>
.BusinessManage{
    margin-bottom: 50px;
}
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
.left {
    float: left;
    width: 50%;
}
.theForm span{
    font-weight: bold;
}
</style>